// src/App.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './LandingPage';
import HomePage from './HomePage';
import Tokens from './Tokens';
import ViewDAT from './ViewDAT';
import About from './About';
import Login from './Login';
import Navigation from './Navigation';
import Release from './Release';
import ViewDatSubmission from './ViewDatSubmission';
import StreamAnalyticsChart from './StreamAnalyticsChart';
import Wallet from './Wallet';
import TokenBlockPage from './TokenBlockPage';
import CashoutPage from './CashoutPage';
import DatDetailPage from './DatDetailPage';
import Admin from './Admin';
import ShowcaseContest from './ShowcaseContest';

function App() {
  const location = useLocation();
  const hideNavRoutes = ['/']; // Add any other routes here where nav should be hidden
  const shouldHideNav = false;

  return (
    <div>
      {!shouldHideNav && <Navigation />}
      <Routes>
        <Route path="/dats" element={<HomePage />} />
        <Route path="/" element={<Tokens />} />
        <Route path="/tdc/block/:id" element={<TokenBlockPage />} />
        <Route path="/wallet" element={<Wallet />} />
                <Route path="/wallet/dat/:id" element={<DatDetailPage />} />
                <Route path="/cashout" element={<CashoutPage />} />
        <Route path="/about" element={<About />} />
                <Route path="/forjudges" element={<ShowcaseContest />} />
        <Route path="/release" element={<Release />} />
                <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/viewdat" element={<ViewDAT />} />
        <Route path="/analytics" element={<StreamAnalyticsChart />} />
        <Route path="/view-dat-submission" element={<ViewDatSubmission />} />
      </Routes>
    </div>
  );
}

export default App;
